import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Validation } from './../../../../models/validation.model';

@Component({
  selector: 'app-validation-msg',
  templateUrl: './validation-msg.component.html',
  styleUrls: ['./validation-msg.component.css']
})
export class ValidationMsgComponent implements OnInit {


  @Input() arrayValidators: any = [];
  @Input() form: FormGroup;
  @Output() formChange: EventEmitter<boolean> = new EventEmitter<any>();
  @Input() validation: Validation;
  @Input() fireInvalidSubmit = false;
  @Output() fireInvalidSubmitChange: EventEmitter<boolean> = new EventEmitter<boolean>();


  constructor(

  ) {
  }

  ngOnInit() {
    this.setCustomValidators(this.form, this.validation);
  }
  setCustomValidators(form: any, validation: Validation){

    let addValidator = {
      required: false,
      min: false,
      max: false,
      minLength: false,
      maxLength: false
    }


    if (form && validation) {

      if (form.controls && form.controls[validation.name]) {

        /*** VALIDATORI GESTITI CON IL SERVIZIO DI VALIDAZIONE ***/

        if (!validation.nullable) {
          addValidator.required = true;
        }
        if (validation.min > 0 || validation.width > 0) {
          if (validation.type == 'String') {
            // per il momento non prendiamo in considerazione il min come stringa
            // addValidator.minLength = true;
            addValidator.maxLength = true;
          } else if (validation.type == 'Number') {
            addValidator.min = true;
            addValidator.max = true;
          }
        }

      }
    }

    if (addValidator.required) this.arrayValidators.push(Validators.required);
    if (addValidator.min) this.arrayValidators.push(Validators.min(validation.min))
    if (addValidator.max) this.arrayValidators.push(Validators.min(validation.width))
    if (addValidator.minLength) this.arrayValidators.push(Validators.minLength(validation.min))
    if (addValidator.maxLength) this.arrayValidators.push(Validators.maxLength(validation.width))

    form.controls[validation.name].setValidators(
      this.arrayValidators
    );

    form.controls[validation.name].updateValueAndValidity();

    this.formChange.emit(form);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/validation-msg/validation-msg.component.ts